import { render } from "./RequirementDetail.vue?vue&type=template&id=08c3a538&scoped=true"
import script from "./RequirementDetail.vue?vue&type=script&lang=js"
export * from "./RequirementDetail.vue?vue&type=script&lang=js"

import "./RequirementDetail.vue?vue&type=style&index=0&id=08c3a538&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c3a538"]])

export default __exports__